import { HttpClient } from '@packages/shared/core/common/services';

export abstract class BaseService {
  protected httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }
}
